<template>
  <div>
      <div class="form-container ou-donation-form">
          <div class="holder jsu-forms">
              <PaymentForm class="form-horizontal">
                  <FormSection title="">
                      <div>
                          <AmountSelector/>                    
                          <ErrorLabel field="amount" />
                      </div>
                  </FormSection>
                  <FormSection v-if="form.amount">
                    <TransactionFee />
                  </FormSection>   
                  <FormSection title="Make it monthly!">
                  <div class="frequency">
                    <PaymentOptions addMonthly monthlyText="Yes, Count me in!" oneTimeText="No, Donate once"/>
                  </div>
                </FormSection>                   
                  <FormSection title="Personal Information">
                      <FormRow inline>      
                          <FormCol field="title" :flex="1" />
                          <FormCol field="firstName" :flex="2" />
                          <FormCol field="lastName" :flex="2" />
                      </FormRow>
                      <FormRow inline>
                          <FormCol field="email" />
                          <FormCol field="phone" />
                      </FormRow>      
                      <FormRow inline>
                      <Consent privacy="https://jsu.org/privacy-policy/"/>
                    </FormRow>                
                      <DonorAddress />
                  </FormSection>
                  <FormSection title="Payment Information" last>
                      <FormRow inline>
                      <FormCol field="card" :showLabel="false"/>
                      </FormRow>
                  </FormSection>
                  <PaymentButton showAmount amountFirst/>
              </PaymentForm>
          </div>
      </div>
  </div>
  </template>
  
  <script lang="ts">
  import {
    computed,
    defineComponent,
  onMounted,
    ref,
    watch
  } from 'vue'
  import { usePaymentForm } from '~/shared/use-payment-form'
  
  export default defineComponent({
    props: {
      subCampaign: String,
    },
    setup() {
      const { getValue, settings, form } = usePaymentForm()
  
  
      return {
        getValue,
        form
              }
    },
  })
  </script>
  <style scoped lang="scss">
  .card-img {
    display: flex;
    img {
      height: 23px;
    }
  }
  
  h3.subtitle{
    text-align: center;
      color: #561045;
      font-size: 22px;
      margin-top: 0px;
      margin-bottom: 35px;  
  }
  ::v-deep h2{
    font-family: 'Poppins';
font-style: normal;
font-weight: 600;
font-size: 30px;
line-height: 36px;
margin-bottom: 20px;
color: #005AE3;
  }
  ::v-deep .styled-radio--ou-donation.styled-radio label{
    background: #DEEAFB;
    border-radius: 8px;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    color: #005AE3;
  }
  ::v-deep .styled-radio--ou-donation.styled-radio input[type='radio']:checked + label {
    background: #005AE3;
    color: white;
}
  ::v-deep .form-container.ou-donation-form{
   box-shadow: none;
   padding: 0px;
   margin: 0px;
   max-width: 100%;
}
  ::v-deep .styled-radio-container.styled-radio-container--ou-donation.row .radio-part{
    min-width: 45%;
    max-width: 45%;
}
  ::v-deep .styled-radio-container--ou-donation.styled-radio-container label{
    background: #FFFFFF;
border: 1px solid #DCE7F8;
box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
border-radius: 24px;
}
  ::v-deep .styled-radio-container--ou-donation.styled-radio-container input[type="radio"]:checked + label,
  ::v-deep #donate-widget-form-submit{
    background: #005AE3;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
border-radius: 24px;
    color: white;
}
  </style>
  
  